<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25">
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      fill="#E1F5FE"
                      d="M11.402 20.166H5.098l-1.375-5.5h9.054l-1.375 5.5zM10.818 4.3l-.026.026c-.18.167-.412.258-.659.258-.258 0-.5-.1-.682-.282-.184-.184-.284-.426-.284-.684 0-.26.1-.501.283-.684l.08-.08c.651-.613 1.487-.97 2.38-1.016-.05.917-.43 1.8-1.092 2.462zM7.203 8.11c-.263.636-.878 1.047-1.567 1.047-.221 0-.439-.044-.647-.13-1.357-.561-2.4-1.677-2.898-3.036.69-.32 1.447-.492 2.208-.492.682 0 1.35.134 1.987.399.419.172.745.498.917.916.174.418.174.878 0 1.296z"
                      transform="translate(-157 -600) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 15) translate(4 1)"
                    />
                    <path
                      fill="#13A2E8"
                      fill-rule="nonzero"
                      d="M13.56.19C11.693-.307 9.62.171 8.153 1.635v.003c-.558.559-.827 1.295-.815 2.028h-.004v.722c-.115-.062-.223-.133-.346-.185-2.41-.999-5.054-.555-6.988.922.322 2.415 1.877 4.597 4.288 5.597 1.03.426 2.14.314 3.046-.184v2.295h1.833V6.238c.992.366 2.15.156 2.947-.64v-.002C13.58 4.131 14.058 2.058 13.56.19zM7.203 8.11c-.263.636-.878 1.047-1.567 1.047-.221 0-.439-.044-.647-.13-1.357-.561-2.4-1.677-2.898-3.036.69-.32 1.447-.492 2.208-.492.682 0 1.35.134 1.987.399.419.172.745.498.917.916.174.418.174.878 0 1.296zm3.615-3.81l-.026.026c-.18.167-.412.258-.659.258-.258 0-.5-.1-.682-.282-.184-.184-.284-.426-.284-.684 0-.26.1-.501.283-.684l.08-.08c.651-.613 1.487-.97 2.38-1.016-.05.917-.43 1.8-1.092 2.462z"
                      transform="translate(-157 -600) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 15) translate(4 1)"
                    />
                    <path
                      fill="#164194"
                      fill-rule="nonzero"
                      d="M0 12.833v1.834h1.834L3.667 22h9.167l1.833-7.333H16.5v-1.834H0zm11.402 7.333H5.098l-1.375-5.5h9.054l-1.375 5.5z"
                      transform="translate(-157 -600) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 15) translate(4 1)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>